import { render, staticRenderFns } from "./MarketingRecommendImport.vue?vue&type=template&id=e0ea962c&scoped=true"
import script from "./MarketingRecommendImport.vue?vue&type=script&lang=js"
export * from "./MarketingRecommendImport.vue?vue&type=script&lang=js"
import style0 from "./MarketingRecommendImport.vue?vue&type=style&index=0&id=e0ea962c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0ea962c",
  null
  
)

export default component.exports